module.exports = __webpack_public_path__ + "static/media/restart.e658bf78.svg";